// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".initials[data-v-684f8a82]{display:block;margin-bottom:20px}.list[data-v-684f8a82]{margin:0 15px 10px 15px}.row-record[data-v-684f8a82]{padding:7px 0;border-bottom:1px solid #ddd}.row-record[data-v-684f8a82]:hover{background-color:#f5f5f5}", ""]);
// Exports
module.exports = exports;
